module.exports = __webpack_public_path__ + "img/payment-pic-06.97ea0825.png";